import * as fromDatatype from '../datatype-library/index';

// linking to other database table.

export interface app_hostname_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  tenant_hdr_guid: fromDatatype.GuidDataFieldInterface;
  hostname_type: fromDatatype.VarcharDatatypeInterface;
  hostname_value: fromDatatype.VarcharDatatypeInterface;
  hostname_url: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  modified_date: fromDatatype.TimestampTzDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  subscription_hdr_guid: fromDatatype.GuidDataFieldInterface;
  cfg_main_guid: fromDatatype.GuidDataFieldInterface;
  website_hdr_guid: fromDatatype.GuidDataFieldInterface;
  distribution_domain_name: fromDatatype.VarcharDatatypeInterface;
  distribution_id: fromDatatype.VarcharDatatypeInterface;
  hosted_zone_id: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  website_init_json: fromDatatype.JsonDatatypeInterface;
  distribution_aliases_json: fromDatatype.JsonDatatypeInterface;
  external_dns_json: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
}


export class app_hostname_hdr_RowClass
  implements app_hostname_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    tenant_hdr_guid: fromDatatype.GuidDataFieldInterface;
    hostname_type: fromDatatype.VarcharDatatypeInterface;
    hostname_value: fromDatatype.VarcharDatatypeInterface;
    hostname_url: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    modified_date: fromDatatype.TimestampTzDatatypeInterface;
    description: fromDatatype.TextDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    subscription_hdr_guid: fromDatatype.GuidDataFieldInterface;
    cfg_main_guid: fromDatatype.GuidDataFieldInterface;
    website_hdr_guid: fromDatatype.GuidDataFieldInterface;
    distribution_domain_name: fromDatatype.VarcharDatatypeInterface;
    distribution_id: fromDatatype.VarcharDatatypeInterface;
    hosted_zone_id: fromDatatype.VarcharDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    website_init_json: fromDatatype.JsonDatatypeInterface;
    distribution_aliases_json: fromDatatype.JsonDatatypeInterface;
    external_dns_json: fromDatatype.JsonDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
  }
